"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _LocaleContext = require("@active/react-utils/i18n/LocaleContext");
var _excluded = ["i18n", "type", "theme", "className", "dismissible", "onClose", "children", "footer"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var THEME_INLINE = 'inline';
var THEME_WCAG = 'wcag';
var iconTypeMap = {
  success: 'check-r',
  warning: 'warning',
  danger: 'cross-r',
  info: 'info-r'
};
var BasicAlert = function BasicAlert(_ref, ref) {
  var i18n = _ref.i18n,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type,
    theme = _ref.theme,
    className = _ref.className,
    dismissible = _ref.dismissible,
    onClose = _ref.onClose,
    children = _ref.children,
    footer = _ref.footer,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var onCloseAlert = (0, _react.useCallback)(function () {
    onClose === null || onClose === void 0 || onClose();
  }, [onClose]);
  var defaultClasses = (0, _classnames["default"])('alert', "alert".concat(theme === THEME_INLINE ? '-inline' : '', "-").concat(type), {
    'alert-dismissible': dismissible,
    'alert-contrast-reconcile': theme === THEME_WCAG
  }, className);
  var iconType = iconTypeMap[type];
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref,
    className: defaultClasses,
    role: "alert"
  }, rest), /*#__PURE__*/_react["default"].createElement("i", {
    className: "ic-".concat(iconType),
    "aria-hidden": "true"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert-content"
  }, children), dismissible && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
    tabIndex: 0,
    onClick: onCloseAlert,
    className: "icon-btn alert-btn-close",
    "aria-label": i18n === null || i18n === void 0 ? void 0 : i18n('react-ui.alert.ariaLabel.closeAlert')
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "ic-cross",
    "aria-hidden": "true"
  }))), footer && /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert-footer"
  }, footer));
};
var Alert = /*#__PURE__*/_react["default"].forwardRef(BasicAlert);
var AlertContainer = (0, _LocaleContext.withI18n)(Alert);
var _default = exports["default"] = AlertContainer;